{
  "version": 1,
  "meta": {
    "id": "polar-express",
    "name": "Polar Express",
    "description": "Navigate the tunnel — circular patterns and spirals await",
    "author": "TriggernometryDash",
    "difficulty": "normal",
    "version": 1,
    "parTime": 65000,
    "optimalInputs": 50,
    "tags": ["complex", "tunnel"]
  },
  "settings": {
    "initialMode": "complex",
    "initialSpeed": 1.0,
    "initialPlayerMode": "triangle",
    "baseColor": "#00ff66",
    "accentColor": "#00ffff",
    "backgroundColor": "#0a0a1a",
    "gridIntensity": 0.6,
    "music": {
      "bpm": 132,
      "key": "Am",
      "style": "synthwave",
      "song": "neon-drive",
      "layers": ["bass", "drums", "arp", "lead"]
    },
    "fog": { "near": 50, "far": 200, "color": "#0a0a1a" }
  },
  "segments": [
    {
      "id": "seg-01-entry",
      "mode": "complex",
      "length": 2000,
      "speed": 1.0,
      "terrain": { "type": "tunnel", "floor": null, "ceiling": null },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-02-rings",
      "mode": "complex",
      "length": 2500,
      "speed": 1.1,
      "terrain": { "type": "tunnel", "floor": null, "ceiling": null },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-03-spirals",
      "mode": "complex",
      "length": 2500,
      "speed": 1.2,
      "terrain": { "type": "tunnel", "floor": null, "ceiling": null },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-04-finale",
      "mode": "complex",
      "length": 1500,
      "speed": 1.3,
      "terrain": { "type": "tunnel", "floor": null, "ceiling": null },
      "obstacles": [],
      "decorations": []
    }
  ],
  "triggers": [
    { "id": "trg-01", "type": "text", "position": 50, "duration": 2500, "easing": "sine-in-out", "params": { "text": "Welcome to Polar coordinates", "style": "floating" } },
    { "id": "trg-02", "type": "text", "position": 600, "duration": 2000, "easing": "sine-in-out", "params": { "text": "Navigate through the rings", "style": "floating" } },
    { "id": "trg-03", "type": "speed", "position": 2000, "duration": 500, "easing": "ease-in", "params": { "speed": 1.1 } },
    { "id": "trg-04", "type": "text", "position": 4000, "duration": 2000, "easing": "sine-in-out", "params": { "text": "The tunnel shifts...", "style": "floating" } },
    { "id": "trg-05", "type": "color", "position": 4500, "duration": 1000, "easing": "sine-in-out", "params": { "baseColor": "#00ffaa", "accentColor": "#44ffff" } },
    { "id": "trg-06", "type": "speed", "position": 6000, "duration": 500, "easing": "ease-in", "params": { "speed": 1.3 } }
  ],
  "collectibles": [
    { "type": "star", "position": { "along": 1500, "across": 0, "up": 0 }, "index": 0 },
    { "type": "star", "position": { "along": 4000, "across": 0, "up": 0 }, "index": 1 },
    { "type": "star", "position": { "along": 7000, "across": 0, "up": 0 }, "index": 2 }
  ]
}
